export interface BaseContactResource {
  id: string;
  gid: string;
  contact_value: string;
  contact_subtype: string;
}

export enum ContactType {
  Email = "email",
  Phone = "phone",
}

export interface EmailContactResource extends BaseContactResource {
  contact_type: ContactType.Email;
}

export interface PhoneContactResource extends BaseContactResource {
  contact_type: ContactType.Phone;
}

export type ContactResource = EmailContactResource | PhoneContactResource;

export type UpdateContactRequestBody = {
  contact_type?: "email_factura" | "email_sale" | "phone";
  contact_value: string;
};

export type CreateContactRequestBody = {
  contact_type: "email_factura" | "email_sale" | "phone";
  contact_value: string;
};
